import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { BaseCardLogicProps } from '../../CardLogicPlugin.types';
import { useCardLogicStore } from '../../model/card-logic.store';
import { CARD_LOGIC_COLUMN_CLASS_NAME, ELEMENT_BY_ID_ATTRIBUTES } from '../../model/constants';

interface CardLogicColumnElementProps extends BaseCardLogicProps {}

const Main = styled.div`
  display: grid;
  gap: 12px;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
`;

export const CardLogicColumnElementEditable = observer((props: CardLogicColumnElementProps) => {
  const { attributes, children, element } = props;
  const cardLogicStore = useCardLogicStore();
  return (
    <Main
      {...attributes}
      {...{ [ELEMENT_BY_ID_ATTRIBUTES]: element.id }}
      className={CARD_LOGIC_COLUMN_CLASS_NAME}
      onMouseDown={() => {
        cardLogicStore.setFocusColumnId(element.id);
      }}
    >
      {children}
    </Main>
  );
});

export const CardLogicColumnElementReadOnly = (props: CardLogicColumnElementProps) => {
  const { attributes, children } = props;
  return (
    <Main
      {...attributes}
      className={CARD_LOGIC_COLUMN_CLASS_NAME}
    >
      {children}
    </Main>
  );
};
